import React from "react";
import Card from "../UI/Card";
import nathanImg from "../../assets/nathan.jpeg";
import fidelImg from "../../assets/fidel.jpeg"
import aliceImg from "../../assets/alice.jpeg"

function Testimonials() {
  const testimonialList = [
    {
      id: "1",
      name: "Nathan M.",
      image: nathanImg ,
      position: "Founder Natefxtraders",
      description:
        '"Proud partner—this innovation redefines success in modern financial trading."',
    },
    {
      id: "2",
      name: "Alice Muthoni",
      image: aliceImg,
      position: "Forex Trader",
      description:
        '"Since using the tool, my forex win rate skyrocketed!"',
    },
    {
      id: "3",
      name: "Fidel Straw",
      image: fidelImg,
      position: "Binary-Options trader",
      description:
        '"These bots are brilliant—profitable, reliable, and easy to use!"',
    },
  ];

  return (
    <div id="testimonials">
      <h1 className="custom-h1">Testimonials</h1>
      <hr className="border-t border-sky-300 my-4" />
      <div className="flex overflow-x-auto space-x-4 px-4 mb-4 scrollbar-hide md:grid  md:grid-cols-3 md:place-items-center md:mb-5">
      {/* <div className="grid  md:grid-cols-3 place-items-center mb-4 mx-auto"> */}
        {testimonialList.map((testimonial) =>(
          

        <Card key={testimonial.id}>
          <div className="rounded-xl">
            <img
              src={testimonial.image}
              alt="Simon Ndiritu"
              className="rounded-full w-16 md:w-24 h-16 md:h-24 mx-auto object-cover "
            />
            <h3 className="font-bold text-xl text-sky-300">{testimonial.name}</h3>
            <p className="text-gray-400 text-sm">{testimonial.position}</p>
            <p className="text-white text-sm font-lora">
              {testimonial.description}
            </p>
          </div>
        </Card>
        ))}
      </div>
    </div>
  );
}

export default Testimonials;
